import axios from 'axios'

export const getBoard = (clientId: string) => {
  return axios.get(`/boards/boards?clientId=${clientId}`)
}

export const getBoardMembers = (boardId: string) => {
  return axios.get(`/boards/boards/${boardId}/members`)
}

export const updateBoardMemberResponsibility = (
  groupId: string,
  assignmentId: number,
  value: string
) => {
  return axios.put(
    `/boards/Boards/${groupId}/assignment/${assignmentId}/responsibility`,
    { responsibility: value }
  )
}
